module.exports = __webpack_public_path__ + "static/img/bg_02.ea902e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_02.jpg
// module id = j7It
// module chunks = 1